var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"changes-saved",class:[_vm.success ? 'text-orange': 'red--text'],attrs:{"data-test":"label-status"}},[_vm._v(" "+_vm._s(_vm.success ? this.$t('labels.changesSaved') : this.$t('labels.errorHappened'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }